import env from 'common/env';

export async function getMarkets() {
    const result = await fetch(`${env}/admin/aot/markets`)
        .then(response => (response.ok ? response.json() : false))
        .then(res => res)
        .catch(error => {
            console.error(error);
            throw 'Echec de la récupération des marchés';
        });

    return result;
}

export async function getMerchants(marketId) {
    const result = await fetch(`${env}/admin/aot/merchants?market_id=${marketId}`)
        .then(response => (response.ok ? response.json() : false))
        .then(res => res)
        .catch(error => {
            console.error(error);
            throw 'Echec de la récupération des commerçants';
        });

    return result;
}

export async function getAots() {
    const formData = new FormData();
    formData.append('search', '');
    formData.append('page', '*');
    formData.append('order', 'asc');
    formData.append('orderBy', 'aot.label');

    const result = await fetch(`${env}/admin/aot/aots/`, {
        method: 'POST',
        body: formData
    })
        .then(response => (response.ok ? response.json() : false))
        .then(res => res)
        .catch(error => {
            console.error(error);
            throw 'Echec de la récupération des aots';
        });

    return result;
}

export async function generateAot(aotId, text, label, marketId, merchants) {
    const formData = new FormData();
    formData.append('aot_id', aotId);
    formData.append('text', text);
    formData.append('label', label);
    formData.append('market_id', marketId);
    formData.append('merchants', JSON.stringify(merchants));

    const result = await fetch(`${env}/admin/aot/aot-merchants/`, {
        method: 'POST',
        body: formData
    })
        .then(response => (response.ok ? response.json() : false))
        .then(res => res)
        .catch(error => {
            console.error(error);
            throw 'Echec de la génération des aots';
        });

    return result;
}

export function pdfPreview(merchantId, marketId, aotId) {
    window.open(
        `${env}/admin/aot/aots/${aotId}/export/preview.pdf?market_id=${marketId}&merchant_id=${merchantId}`,
        '_blank'
    );
}
